module.exports = __webpack_public_path__ + "img/04.4b7b0a7b.jpg";